export const percyApp = () => {
    const result = document.createElement('percy-app');
    const percyBody = document.createElement('percy-body');
    percyBody.setAttribute('role', 'main');
    result.appendChild(percyBody);
    return result;
};
